import moment from "moment";
import { useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Post from "../../api/Post";
import SimpleLoad from "../../loader/SimpleLoad";
import {
  ADD_APPOINTMENT,
  SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
  UPDATE_APPOINTMENT_SIN_TOKEN,
} from "../../api/Routes";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import { getIpPublic } from "../../utils/getIpPublic";
import Put from "../../api/Put";
import { getSource } from "../../utils/getSource";
import { getTokenExternal } from "../../utils/getTokenExternal";
import { useEffect } from "react";
import ModalInformacionParaPago from "../pagos/ModalInformacionParaPago";
import { BAZ_ACCOUNT_ID } from "../../constants/urls";

function StepTree({
  t,
  next,
  initialData,
  prev,
  setReservadoExitosamente,
  reservadoExitosamente,
  isPedienteAprobacion,
  setValidLink,
  companyType,
  onDemand,
  appointment,
  source,
  setPayment,
  setPaymentStatus,
  configuration,
}) {
  const [doctor, setDoctor] = useState(null);
  const [show, setShow] = useState(false);
  const [isSubmitting, setIsSubmiting] = useState(false);
  const [checkedTerms, setCheckedTerms] = useState(false);
  const handleClose = () => setShow(false);
  const [openModalPago, setOpenModalPago] = useState(false);
  const [hasCopayment, setHasCopayment] = useState(
    initialData.account.hasCopayment ?? false
  );
  const [objPayment, setObjPayment] = useState(null);
  const [citaCostoMoneda, setCitaCostoMoneda] = useState({
    costo: null,
    currency: "",
  });
  const [failPayment, setFailPayment] = useState(false);

  useEffect(() => {
    const idEspecialidad = initialData.especialidadId;
    const especilidadDetail =
      initialData.account?.specialtyDurationList?.filter(
        (item) => item.especialty?.id === idEspecialidad
      );
    let hasCopaymentEspeciality = false;
    if (especilidadDetail.length) {
      hasCopaymentEspeciality = especilidadDetail[0].hasCopayment ?? false;
      const costo = especilidadDetail[0].amountPayment ?? null;
      const currency = especilidadDetail[0].currency?.code ?? null;
      setCitaCostoMoneda({
        costo: costo,
        currency: currency,
      });
    }
    setHasCopayment(
      initialData.account.hasCopayment && hasCopaymentEspeciality
    );
  }, []);

  const [errorServer, setErrorServer] = useState(null);
  const [showModalServer, setShowModalServer] = useState(false);
  const handleCloseModalServer = () => {
    setShowModalServer(false);
  };

  const sourceObj = getSource(source);
  const handleMakeAppointment = (confirmado) => {
    if (confirmado) {
      if (checkedTerms) {
        setIsSubmiting(true);
        getIpPublic()
          .then((resp) => {
            // Check if we need to send cardLastDigits in externalId
            const shouldUseCardLastDigits = 
              initialData.account?.id === BAZ_ACCOUNT_ID;
            const externalIdValue = shouldUseCardLastDigits 
              ? initialData.cardLastDigits 
              : initialData.externalId;

            let d = {
              source: sourceObj,
              appointmentStatus: hasCopayment
                ? "PendientePago"
                : initialData.account && initialData.account.automaticValidation
                ? "Pagada"
                : "Pendiente",
              patient: {
                id: initialData.id,
                name: initialData.name,
                middleName: initialData.middleName,
                seccondSurname: initialData.seccondSurname,
                lastName: initialData.lastName,
                email: initialData.email,
                phoneNumber: initialData.phoneNumber,
                phoneNumber2: initialData.phoneNumber2,
                curp: initialData.curp,
                gender: initialData.gender,
                dateOfBirthday: initialData.dateOfBirthday,
                account: initialData.account,
                externalId: externalIdValue,
              },
              schedule: initialData.schedule,
              especialty: {
                id: initialData.especialidadId,
              },
              linkPatient: initialData.linkPatient,
              legalWarnings: [
                {
                  acceptPatient: "approved",
                  ipAddress: resp,
                  legalWarningType: "InformedConsent",
                },
              ],
            };
            getTokenExternal()
              .then((resToken) => {
                Post({
                  url: ADD_APPOINTMENT,
                  data: d,
                  header: true,
                  access_token: resToken.data.access_token,
                })
                  .then((response) => {
                    console.log(response);
                    if (response.data.state) {
                      setDoctor(response.data.data.scheduleDTO.doctor);
                      setIsSubmiting(false);
                      setReservadoExitosamente(true);
                      if (hasCopayment) {
                        setOpenModalPago(true);
                        setObjPayment(response.data.data.payment);
                      }
                    } else {
                    }
                  })
                  .catch((error) => {
                    setIsSubmiting(false);
                    setShowModalServer(true);
                    if (error.response) {
                      setErrorServer(error.response);
                    }
                  });
              })
              .catch((er) => {
                setShowModalServer(true);
                if (er.response) {
                  setErrorServer(er.response);
                }
                setIsSubmiting(false);
              });
          })
          .catch((err) => {
            // Check if we need to send cardLastDigits in externalId
            const shouldUseCardLastDigits = 
              initialData.account?.id === BAZ_ACCOUNT_ID;
            const externalIdValue = shouldUseCardLastDigits 
              ? initialData.cardLastDigits 
              : initialData.externalId;

            let d = {
              source: sourceObj,
              account: initialData.account,
              appointmentStatus:
                initialData.account && initialData.account.automaticValidation
                  ? "Pagada"
                  : "Pendiente",
              patient: {
                id: initialData.id,
                name: initialData.name,
                middleName: initialData.middleName,
                seccondSurname: initialData.seccondSurname,
                lastName: initialData.lastName,
                email: initialData.email,
                phoneNumber: initialData.phoneNumber,
                phoneNumber2: initialData.phoneNumber2,
                curp: initialData.curp,
                gender: initialData.gender,
                dateOfBirthday: initialData.dateOfBirthday,
                account: initialData.account,
                externalId: externalIdValue,
              },
              schedule: initialData.schedule,
              especialty: {
                id: initialData.especialidadId,
              },
              linkPatient: initialData.linkPatient,
              legalWarnings: [
                {
                  acceptPatient: "approved",
                  legalWarningType: "InformedConsent",
                },
              ],
            };

            getTokenExternal()
              .then((resToken) => {
                Post({
                  url: ADD_APPOINTMENT,
                  data: d,
                  header: true,
                  access_token: resToken.data.access_token,
                })
                  .then((response) => {
                    setDoctor(response.data.data.scheduleDTO.doctor);
                    setIsSubmiting(false);
                    setReservadoExitosamente(true);
                  })
                  .catch((error) => {
                    setShowModalServer(true);
                    if (error.response) {
                      setErrorServer(error.response);
                    }
                    setIsSubmiting(false);
                  });
              })
              .catch((er) => {
                setShowModalServer(true);
                if (er.response) {
                  setErrorServer(er.response);
                }
                setIsSubmiting(false);
              });
          });
      }
    } else {
      if (onDemand) {
        getIpPublic()
          .then((response) => {
            let d = {
              id: appointment.id,
              appointmentStatus: "Cancelada",
              legalWarnings: [
                {
                  acceptPatient: "declined",
                  ipAddress: response,
                  legalWarningType: "InformedConsent",
                },
              ],
            };
            console.log(d);
            Put({ url: UPDATE_APPOINTMENT_SIN_TOKEN, data: d, header: false })
              .then((response) => {
                setValidLink(false);
              })
              .catch((error) => {
                setShowModalServer(true);
                if (error.response) {
                  setErrorServer(error.response);
                }
              });
          })
          .catch((err) => {
            let d = {
              id: appointment.id,
              appointmentStatus: "Cancelada",
              legalWarnings: [
                {
                  acceptPatient: "declined",
                  ipAddress: "",
                  legalWarningType: "InformedConsent",
                },
              ],
            };
            console.log(d);
            Put({ url: UPDATE_APPOINTMENT_SIN_TOKEN, data: d, header: false })
              .then((response) => {
                setValidLink(false);
              })
              .catch((error) => {
                setShowModalServer(true);
                if (error.response) {
                  setErrorServer(error.response);
                }
              });
          });
      } else {
        let d = {
          id: initialData.linkPatient,
          active: false,
        };
        console.log("Step3: ", d);
        setValidLink(false);
        Post({
          url: SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
          data: d,
          header: false,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            setShowModalServer(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
      }
    }
  };
  const closeTab = () => {
    //window.open("about:blank", "_self");
    //window.close();
    window.location.reload();
  };

  const onClickGoPayment = () => {
    setOpenModalPago(false);
    if (!objPayment || objPayment === undefined) {
      setFailPayment(true);
    } else {
      setFailPayment(false);
      setPayment(objPayment);
      window.open(objPayment.url, "_blank", "noopener,noreferrer");
    }
  };

  return failPayment ? (
    <Row className="h-100vh">
      <Col xs="12" md={{ span: 4, offset: 4 }}>
        <Card>
          <Card.Body>
            <div className="text-center">
              <p>
                Sr(a). Usuario: Su cita no pudo ser agendada, por favor realice
                nuevamente el proceso de agendamiento.
              </p>
              <Button
                type="button"
                variant="secondary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Iniciar nuevamente
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  ) : (
    <>
      {reservadoExitosamente && !hasCopayment ? (
        <Row>
          <Col xs="12" md={{ span: 4, offset: 4 }}>
            <Card>
              <Card.Body>
                <div className="text-center">
                  <h5>{t("citas_nosotros")}</h5>
                  {doctor && (
                    <h6>{`Medico: ${doctor.name} ${doctor.lastName}`}</h6>
                  )}
                  <p>{t("contactare_breve")}</p>
                  <Button type="button" variant="secondary" onClick={closeTab}>
                    Finalizar
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        !reservadoExitosamente && (
          <Card className="mb-3">
            <Card.Header className="text-center">
              <h5>{t("confirmar_servicio")}</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                {/* <Col xs="12" md="6">
                                <h4 className="color-blue-dark">{t('informacion_medico')}</h4>
                                <Row>
                                    <Col xs="12" md="12">
                                        <label className="mb-2"><strong>{t('medico')}: </strong>{initialData.doctorName}</label>
                                    </Col>
                                </Row>
                            </Col> */}
                <Col xs="12" md="12">
                  <h4 className="color-blue-dark">
                    {t("paciente_informacion")}
                  </h4>
                  <Row>
                    <Col xs="12" md="12">
                      <label className="mb-2">
                        <strong className="text-capitalize">
                          {t("paciente")}:{" "}
                        </strong>
                        {`${initialData.name} ${
                          initialData?.middleName ?? ""
                        } ${initialData.lastName} ${
                          initialData?.seccondSurname ?? ""
                        }`}
                      </label>
                    </Col>
                    <Col xs="12" md="12">
                      <label className="mb-2">
                        <strong>{t("Telefono")}: </strong>
                        {initialData ? initialData.phoneNumber : "-"}
                      </label>
                    </Col>
                    <Col xs="12" md="12">
                      <label className="mb-2">
                        <strong>{t("Correoelectronico")}: </strong>
                        {initialData ? initialData.email : "-"}
                      </label>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  <h4 className="color-blue-dark text-center mb-4">
                    {t("informacion_servicio")}
                  </h4>
                  <Row>
                    <Col xs="12" md="6">
                      <Row>
                        <Col xs="12" md="12">
                          <label className="mb-2">
                            <strong>{t("tipo_servicio")}: </strong>
                            {t("telemedicina")} ({t("videollamada")})
                          </label>
                        </Col>
                        <Col xs="12" md="12">
                          <label className="mb-2">
                            <strong>{t("especialidad")}: </strong>
                            {initialData.especialidadName}
                          </label>
                        </Col>
                        <Col xs="12" md="12">
                          <label className="mb-2">
                            <strong>{t("dia_hora")}: </strong>
                            {moment(
                              initialData.schedule.hourInit,
                              "DD-MM-YYYY HH:mm:ss"
                            ).format("DD-MM-YYYY HH:mm")}
                          </label>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12" md="6">
                      <div className="text-center">
                        <h6>{t("telemedicina")}</h6>
                        <p className="font-size-08rem">
                          {t("telemedicina_confirm")}
                        </p>
                        {/* {isPedienteAprobacion && <p className="text-info">{t('cita_pendiente_aprobacion')}</p>} */}
                        <p className="font-size-08rem">
                          {t("telemedicina_confirm1")}
                        </p>
                        <p className="font-size-08rem">
                          {t("cancelar_cita_text")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="text-right">
                  <Button type="button" variant="light" onClick={prev}>
                    {t("regresar")}
                  </Button>{" "}
                  <Button
                    type="button"
                    variant="primary"
                    onClick={(e) => setShow(true)}
                  >
                    {t("confirmar")}
                  </Button>
                </Col>
              </Row>
            </Card.Body>

            <Modal
              show={show}
              onHide={handleClose}
              centered
              className="border-0"
              size="lg"
            >
              <Modal.Body className="p-2">
                <div className="position-relative overflow-hidden">
                  {isSubmitting && <SimpleLoad />}
                  <h5 className="text-uppercase">
                    {t("consentimiento_telesalud")}
                  </h5>
                  <hr />
                  <p className="font-size-08rem mb-0">
                    {t("consentimiento_mexico")}{" "}
                    <a
                      href="https://ikeasistencia.com/aviso-legal-y-de-privacidad/"
                      target="blank"
                    >
                      {t("siguiente_link")}
                    </a>
                    .
                  </p>
                  <p className="font-size-08rem mb-0">
                    <strong>
                      {t("fecha")} {moment().format("dddd DD MMMM YYYY HH:mm")}{" "}
                    </strong>
                  </p>
                  <p className="font-size-08rem mb-0">
                    {t("soy")}{" "}
                    <strong>{`${initialData.name} ${initialData.middleName} ${initialData.lastName} ${initialData.seccondSurname}`}</strong>{" "}
                    {t("representante_legal")}
                  </p>
                  <div className="mt-3">
                    <Form.Group className="text-center">
                      <Form.Check
                        type="checkbox"
                        label={t("acepto")}
                        className="checked-terms"
                        onChange={(e) => setCheckedTerms(e.target.checked)}
                      />
                    </Form.Group>
                  </div>

                  <Row className="text-center">
                    <Col>
                      <Button
                        variant="link"
                        className="text-danger font-weight-bold"
                        onClick={(e) => handleMakeAppointment(false)}
                      >
                        Declinar
                      </Button>{" "}
                      <Button
                        variant="outline-success"
                        className="ok-buttom"
                        onClick={(e) => handleMakeAppointment(true)}
                        disabled={!checkedTerms}
                      >
                        {t("aceptar")}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Modal.Body>
            </Modal>

            <ComponentModalErrorSever
              show={showModalServer}
              handleClose={handleCloseModalServer}
              error={errorServer}
            />
          </Card>
        )
      )}
      <ModalInformacionParaPago
        cita={citaCostoMoneda}
        open={openModalPago}
        setOpen={setOpenModalPago}
        onClickGoPayment={onClickGoPayment}
        setPaymentStatus={setPaymentStatus}
        configuration={configuration}
      />
    </>
  );
}

export default withTranslation()(StepTree);